import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { ITopLevelAnalytic } from '~/types/analytic'

import Variation from '~/components/Variation'
import { getNumberWithSpaces } from '~/utils/number'

import './styles.scss'

interface Props {
  areSiblingsLoaded?: boolean
  className?: string
  doubleComparaison?: boolean
  metrics?: ITopLevelAnalytic
  period?: string
  title: string
  wau?: boolean
}

const AnalyticsPreview = ({
  areSiblingsLoaded,
  className,
  doubleComparaison,
  metrics,
  period,
  title,
  wau,
}: Props): ReactElement | null => {
  const componentClassnames = classNames('analytics-preview-component', className)

  if (!metrics || !areSiblingsLoaded) {
    return null
  }

  const variationDirection = !doubleComparaison
    ? wau
      ? metrics?.direction_7d
      : metrics?.direction_30d
    : metrics?.direction_1d

  const variationValue = !doubleComparaison
    ? wau
      ? metrics?.relative_diff_7d
      : metrics?.relative_diff_30d
    : metrics?.relative_diff_1d

  return (
    <div className={componentClassnames}>
      <div className="title">{title}</div>
      <div className="value">{getNumberWithSpaces(metrics.value_at_date)}</div>
      <div className="variations">
        <Variation direction={variationDirection} period={period} periodValue={1} value={variationValue} />
        {doubleComparaison ? (
          <Variation
            direction={metrics.direction_7d}
            period={period}
            periodValue={7}
            value={metrics.relative_diff_7d}
          />
        ) : null}
      </div>
    </div>
  )
}

export default AnalyticsPreview
